export default __webpack_public_path__ + "static/3-2cbe0483a572d3439d1076f60905b583.jpg";